export const DEFAULT_SETTINGS = {
  currency: 'ILS',
  currencySymbol: '₪',
  locale: 'he-IL',
  firstDayOfMonth: 1,
  darkMode: false,
  budgetStep: 100,
  colorBlindMode: false,
};

export const DEFAULT_CATEGORIES = [
  { id: 'salary',        name: 'Salary',        type: 'income'  },
  { id: 'freelance',     name: 'Freelance',      type: 'income'  },
  { id: 'other-income',  name: 'Other Income',   type: 'income'  },
  { id: 'rent',          name: 'Rent',           type: 'expense' },
  { id: 'groceries',     name: 'Groceries',      type: 'expense' },
  { id: 'transport',     name: 'Transport',      type: 'expense' },
  { id: 'utilities',     name: 'Utilities',      type: 'expense' },
  { id: 'dining',        name: 'Dining Out',     type: 'expense' },
  { id: 'entertainment', name: 'Entertainment',  type: 'expense' },
  { id: 'health',        name: 'Health',         type: 'expense' },
  { id: 'education',     name: 'Education',      type: 'expense' },
  { id: 'clothing',      name: 'Clothing',       type: 'expense' },
];

export const CHART_COLORS = [
  '#2f7d6b', '#3f7fae', '#d39a3f', '#cf6a5a', '#7a9e8f', '#6fc3a8',
];

// Pie chart palettes: index 0 = darkest (biggest slice), last = lightest (smallest slice)
export const EXPENSE_PIE_SHADES = [
  '#1d6b59', '#2f8270', '#4a9787', '#69ac9e', '#8cc1b6', '#b0d5cd', '#d2e7e2',
];
export const SAVINGS_PIE_SHADES = [
  '#2c6a9a', '#3f7fae', '#5f9bc4', '#7fb0d2', '#a3c8df', '#c2dcec', '#dceaf4',
];

// 20 perceptually distinct colors for color-blind mode
export const COLORBLIND_COLORS = [
  '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231',
  '#911eb4', '#42d4f4', '#f032e6', '#bfef45', '#fabed4',
  '#469990', '#dcbeff', '#9a6324', '#fffac8', '#800000',
  '#aaffc3', '#808000', '#ffd8b1', '#000075', '#a9a9a9',
];

export const MONTH_NAMES = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

export const MONTH_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const STORAGE_KEYS = {
  dataVersion:       'bgt_data_version',
  settings:          'bgt_settings',
  categories:        'bgt_categories',
  budgetItems:       'bgt_budget_items',
  transactions:      'bgt_transactions',
  buckets:           'bgt_buckets',
  yearlyExp:         'bgt_yearly_expenses',
  currencyBalances:  'bgt_currency_balances',
  recurringTemplates:'bgt_recurring_templates',
  theme:             'bgt_theme',
  // Google Drive sync (non-sensitive metadata only — tokens are never persisted)
  googleClientId:    'bgt_google_client_id',
  googleDriveEmail:  'bgt_google_drive_email',
  googleDriveOn:     'bgt_google_drive_enabled',
  googleDriveSync:   'bgt_google_drive_last_sync',
  googleDriveFileId:   'bgt_google_drive_file_id',
  googleDriveFileName: 'bgt_google_drive_file_name',
  googleDriveAutoSave: 'bgt_google_drive_autosave',
  // Exchange rate cache — shared across all foreign-currency buckets
  fxRates:           'bgt_fx_rates',
};

// Map currency symbol → code for paste import detection
export const SYMBOL_TO_CODE = { '₪': 'ILS', '$': 'USD', '€': 'EUR', '£': 'GBP', '¥': 'JPY', 'Fr': 'CHF' };

// Header-keyword regexes shared between Excel detection and column mapping.
// Case-insensitive, tolerant of whitespace / punctuation / Hebrew.
export const EXCEL_HEADER_KEYWORDS = {
  date:        /(^|\s|\b)(date|posted|purchase\s*date|תאריך)/i,
  notes:       /(^|\s|\b)(notes?|memo|comment|הערות|פירוט\s*נוסף)/i,
  description: /(^|\s|\b)(description|merchant|business|narration|details|payee|שם\s*בית\s*עסק|שם\s*עסק|שם|עסק|פירוט)/i,
  currency:    /(^|\s|\b)(currency|מטבע)/i,
  charge:      /(^|\s|\b)(charge|billed|billing|סכום\s*חיוב|חיוב)/i,
  amount:      /(^|\s|\b)(amount|sum|value|סכום)/i,
  debit:       /(^|\s|\b)(debit|הוצאה|חובה)/i,
  credit:      /(^|\s|\b)(credit|הכנסה|זכות)/i,
  balance:     /(^|\s|\b)(balance|יתרה)/i,
  receiptId:   /(^|\s|\b)(receipt|reference|ref\s*id|שובר|מספר\s*עסקה)/i,
};
